import { PlaygroundProvider } from "../context/PlaygroundContext";
import { PlaygroundExperience } from "../components/PlaygroundExperience";

export function PlaygroundPage() {
  return (
    <PlaygroundProvider>
      <PlaygroundExperience />
    </PlaygroundProvider>
  );
}

export default PlaygroundPage;
